<template>
  <div class="app-button-group">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseButtonGroup',
}
</script>

<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/button-group";
</style>
